import React from 'react';
import { Navbar, Nav, Container, Card, Button, Table, Row, Col, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

// Data for the recognition logos
const recognitions = [
    { name: 'RGUHS', logoUrl: '/static/rguhs.webp' },
    { name: 'IAGES', logoUrl: '/static/iages.webp' },
    { name: 'HSI', logoUrl: '/static/hsi.webp' },
    { name: 'APHS', logoUrl: '/static/aphs.webp' },
    { name: 'FOGSI', logoUrl: '/static/fogsi.webp' },
];

// Data for the course includes list
const courseIncludes = [
    'Diadactic Sessions & Telelectures by Esteemed National Faculty',
    'Hands-on Training',
    'Video Demonstration',
    'Live Surgical Demonstration',
    'Panel Discussion',
    'Assisting Laparoscopic Surgery'
];

const CourseSection = ({ title, description, director, imageUrl, imagePosition = 'left' }) => {

    // Define the props for the columns, including the correct responsive ordering
    const imageColProps = {
        md: { span: 7, order: imagePosition === 'left' ? 1 : 2 },
        xs: { order: 1 }
    };

    const textColProps = {
        md: { span: 5, order: imagePosition === 'left' ? 2 : 1 },
        xs: { order: 2 }
    };

    return (
        <Card className="mb-5 border-0 shadow-sm" style={{ backgroundColor: '#dadada' }}>
            <Row className="g-0">
                {/* Image Column */}
                <Col {...imageColProps} className="d-flex align-items-center">
                    <Card.Img
                        src={imageUrl}
                        alt={title}
                        className="img-fluid rounded"
                        style={{ height: "100%", objectFit: 'cover' }}
                        // Add a placeholder in case the image fails to load
                        onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/600x400/E0E0E0/333?text=Image+Not+Found'; }}
                    />
                </Col>

                {/* Text Content Column */}
                <Col {...textColProps} className="d-flex align-items-center">
                    <Card.Body className="p-lg-5 text-center text-md-start">
                        <h2 className="fw-bold">{title}</h2>
                        <p className="lead text-muted">{description}</p>
                        <p className="mb-4"><strong>Course Director:</strong> {director}</p>
                        <Button href='/register' variant="primary" size="lg" className="px-4 rounded-pill">Enrol Now</Button>
                    </Card.Body>
                </Col>
            </Row>
        </Card>
    );
};

// Component for the "Recognised By" section
const RecognisedBy = () => (
    <div className="text-center my-5">
        <h1 className="fw-bold">BEST Institute and Research Center</h1>
        <p className="mb-4">Recognised by</p>
        <Row className="justify-content-center align-items-center g-4">
            {recognitions.map((rec, index) => (
                // Responsive columns for logos
                <Col key={index} xs={6} sm={4} md={2} className="text-center">
                    <img src={rec.logoUrl} alt={rec.name} className="img-fluid mb-2" style={{ maxHeight: '100px' }} />
                    <p className="fw-bold">{rec.name}</p>
                </Col>
            ))}
        </Row>
    </div>
);

// Component for the "Training Course Includes" section
const CourseIncludes = () => (
    <Card className="my-5 border-0" style={{ backgroundColor: '#e8e3de' }}>
        <Card.Body className="p-4 p-md-5">
            <h1 className="text-center mb-5 fw-bold">TRAINING COURSES IN LAPAROSCOPIC SURGERY</h1>
            <h3 className="mb-3 fw-bold">Training Course Includes</h3>
            <ListGroup variant="flush">
                {courseIncludes.map((item, index) => (
                    <ListGroup.Item key={index} className="ps-0" style={{ backgroundColor: '#e8e3de' }}>
                        • {item}
                    </ListGroup.Item>
                ))}
            </ListGroup>
        </Card.Body>
    </Card>
);

const TrainingPrograms = () => {

    const courses = [
        {
            title: 'Comprehensive Laparoscopic Surgery Training Course',
            description: 'Duration 10 days For surgeons & gynaecologists',
            director: 'Dr. M Ramesh',
            imageUrl: '/static/tp1.webp',
            imagePosition: 'right'
        },
        {
            title: 'Laparoscopic Knotting & Suturing Course',
            description: 'Duration 2 days Live surgical demonstration. Hands on training on Endotrainers',
            director: 'Dr. M Ramesh',
            imageUrl: '/static/tp2.webp',
            imagePosition: 'left'
        },
        {
            title: 'Laparoscopic Hernia Surgery Training Course',
            description: 'Duration 3 days Live surgical demonstration Cadaver Surgery',
            director: 'Dr. M Ramesh',
            imageUrl: '/static/tp3.webp',
            imagePosition: 'right'
        },
        {
            title: 'Laparoscopic Bariatric Surgery Training Course',
            description: 'Duration 3 days Live surgical demonstration Hands on training on Endotrainers',
            director: 'Dr. M Ramesh',
            imageUrl: '/static/tp4.webp',
            imagePosition: 'left'
        }
    ];

    return (
        <>
            <div className="hero-section text-center text-white" style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/static/tp-hero.webp')`, // Replace with your hero image
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '100px 0',
                minHeight: '40vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                
            </div>


            {/* Main Content */}
            <Container className="my-5">
                <RecognisedBy />
                <CourseIncludes />

                <div style={{ backgroundColor: '#f8f9fa' }}>
                    <Container className="py-5">
                        <h1 className="text-center fw-bold mb-5">Our Training Courses</h1>
                        {courses.map((course, index) => (
                            <CourseSection
                                key={index}
                                title={course.title}
                                description={course.description}
                                director={course.director}
                                imageUrl={course.imageUrl}
                                imagePosition={course.imagePosition}
                            />
                        ))}
                    </Container>
                </div>

                <h2 className="text-center my-5">Fee Structure</h2>

                <Table striped bordered hover style={{ maxWidth: '500px', margin: '0 auto' }}>
                    <thead>
                        <tr>
                            <th>Duration</th>
                            <th>Fee</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>10 Days</td>
                            <td>60,000</td>
                        </tr>
                        <tr>
                            <td>1 Month</td>
                            <td>90,000</td>
                        </tr>
                        <tr>
                            <td>3 Months</td>
                            <td>2,50,000</td>
                        </tr>
                        <tr>
                            <td>6 Months</td>
                            <td>4,00,000</td>
                        </tr>
                        <tr>
                            <td>1 Year</td>
                            <td>6,00,000</td>
                        </tr>
                        <tr>
                            <td>Bariatric surgery course 3 days</td>
                            <td>50,000</td>
                        </tr>
                        <tr>
                            <td>Hernia surgery course 3 days</td>
                            <td>50,000</td>
                        </tr>
                    </tbody>
                </Table>
                <p className="text-center">18% GST Applicable</p>
            </Container>

            <Footer />
        </>
    )
}

export default TrainingPrograms;
